<style scoped>
.column {
  float: left;
  width: 50%;
}
@media screen and (max-width: 600px) {
  .column {
    width: 100%;
  }
}

h4 {
  margin-top: 40px;
  font-size: 30pt;
}
.heart-button span{
  width: 100%;
  height: 100%;
  display: block;
  text-align: center;
  padding-top: 50px;
  font-size: 2rem;
  text-transform: uppercase;
  font-weight: bold;
  }
a.heart-button:link {
  text-decoration: none;
}

a.heart-button:visited {
  text-decoration: none;
}
</style>

<template>
  <section id="hero">
    <v-img
      :min-height="minHeight"
      :src="require('@/assets/home-hero.png')"
      class="white--text"
      gradient="to right, rgba(5, 11, 31, .3), rgba(5, 11, 31, .8)"
    >
      <v-container class="fill-height px-4 py-12">
        <v-responsive class="d-flex align-top" height="100%" width="100%">
          <div class="column">
            <v-img
              :src="require('@/assets/covers/marianne-title.png')"
              max-width="600"
              width="100%"
              style="filter: invert(100%);"
            />

            <div style="font-size: 24px; margin-bottom: 40px;">
              <p>Marianne would probably be considered PG-13.</p>
              <p>TW: ED</p>
              
              <h4>Violence &amp; Gore</h4>
              <p>Mild, mostly humorous</p>
              <ul>
                <li>Shoving</li>
                <li>Accidents</li>
                <li>Humorous references</li>
                <li>Characters throw things at others</li>
              </ul>
              
              <h4>Profanity</h4>
              <p>Mild</p>
              <ul>
                <li>Jackass, dumbass, bitchy, bitch-slap</li>
                <li>No four letter words</li>
              </ul>
              
              <h4>Alcohol, Drugs &amp; Smoking</h4>
              <p>Moderate</p>
              <ul>
                <li>Underage drinking</li>
                <li>Smoking</li>
                <li>A character smokes pot (1)</li>
                <li>Multiple slight references/jokes about drugs</li>
              </ul>
              
              <h4>Frightening &amp; Intense Scenes</h4>
              <p>None</p>
              
              <h4>Sex &amp; Nudity</h4>
              <p>PG-13</p>
              <ul>
                <li>Kissing</li>
                <li>Make out scenes, no specifics (2)</li>
                <li>A group of women go skinnydipping (non-sexual)</li>
                <li>Implied unmarried sex outside of novel time-line (2)</li>
              </ul>
            </div>

            <div
              :class="$vuetify.breakpoint.smAndDown ? 'flex-column align-start' : 'align-center'"
              class="d-flex flex-wrap"
            >
              <a href="https://www.amazon.com/dp/B08RWNXSXJ" target="_blank" class="heart-button">
                <v-img :src="require('@/assets/heart-button.png')" width="240" height="160" contain><span>Buy Now</span></v-img>
              </a>
              <span class="font-weight-bold ml-6 mr-4 my-4">or</span>
              <base-btn
                :to="{ name: 'Marianne' }"
                :ripple="false"
                class="pa-1"
                height="auto"
                text
              >read the sample</base-btn>
            </div>
          </div>

          <a href="https://www.amazon.com/dp/B08RWNXSXJ">
            <base-img
              :src="require('@/assets/covers/marianne-book.png')"
              class="column"
              contain
              max-width="600"
              href="https://www.amazon.com/dp/B08RWNXSXJS"
            />
          </a>
        </v-responsive>
      </v-container>
    </v-img>
  </section>
</template>

<script>
export default {
  name: "SectionContentGuide",

  provide: {
    theme: { isDark: true },
  },

  computed: {
    minHeight() {
      const height = this.$vuetify.breakpoint.mdAndUp ? "100vh" : "50vh";

      return `calc(${height} - ${this.$vuetify.application.top}px)`;
    },
  },
};
</script>
